<template>
	<!-- Providers -->
	<div
		class="select-provider"
		v-if="ui.selectingProvider && activities.selected"
	>
		<div class="book-time-single-date-xs margin-top-xs-2">
			<div class="row">
				<div class="col-xs-12 padding-bottom-xs-2">
					<ul class="nk-list nk-list-two-columns-md fade-on-hover">
						<li
							v-for="provider in providers.available"
							:key="'select-provider-' + provider"
						>
							<a
								href="#"
								@click.prevent="
									setProvider(provider);
									selectedSlot = false;
								"
								class="force-icon-right"
								v-bind:class="{
									'text-gray':
										providers.selected != provider &&
										providers.selected
								}"
								>{{ formatProviderNameInList(provider) }}</a
							>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
	components: {},
	computed: {
		...mapState(["providers", "ui", "activities"]),
		...mapGetters(["formatProviderNameInList"])
	},
	methods: {
		...mapActions(["setProvider"])
	}
};
</script>